import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteScheduleNote } from "@/adapters/api";

export function useDeleteScheduleNote(constructionId: string | undefined) {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (noteId: string) => {
			if (!constructionId) throw new Error("missing construction");
			return deleteScheduleNote(constructionId, noteId);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ["schedule-notes", constructionId],
			});
		},
	});
}
